export class PlanningResourcesReferenceMapService {
    getPlanningResourcesReferenceMapDetails([details]) {
        const { values } = details;
        const [ content ] = values;
        const {embed_code:embedCode, description, images, videos} = content;
        
        return {
            embedCode,
            description,
            images,
            videos
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/planning-resources-reference-map/planning-resources-reference-map.service.js